// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer_footer_section__YRY81 {
  padding: 50px 30px 0;
}
.footer_footer_section__YRY81 .footer_main__Dmzml {
  display: flex;
  padding-bottom: 50px;
}
.footer_footer_section__YRY81 .footer_main__Dmzml .footer_logo_part__txaGp {
  width: 25%;
}
.footer_footer_section__YRY81 .footer_main__Dmzml .footer_logo_part__txaGp .footer_logo_link__LC4y2 {
  margin-bottom: 80px;
  width: 150px;
  border-radius: 50%;
}
.footer_footer_section__YRY81 .footer_main__Dmzml .footer_logo_part__txaGp .footer_logo_link__LC4y2 img {
  width: 100%;
  object-fit: contain;
  border-radius: 50%;
}
.footer_footer_section__YRY81 .footer_main__Dmzml .footer_logo_part__txaGp .footer_logo_link__LC4y2 a::before {
  content: none !important;
}
.footer_footer_section__YRY81 .footer_main__Dmzml .footer_logo_part__txaGp .footer_our_social_wrap__62eIC .footer_title__kLu66 {
  font-weight: 700;
  font-size: 21px;
  line-height: 18px;
  margin-bottom: 15px;
}
.footer_footer_section__YRY81 .footer_main__Dmzml .footer_logo_part__txaGp .footer_our_social_wrap__62eIC .footer_footer_social_links__nTS8Y {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid var(--primary-color);
  border-radius: 50%;
  margin-right: 10px;
  transition: all 0.3s;
}
.footer_footer_section__YRY81 .footer_main__Dmzml .footer_logo_part__txaGp .footer_our_social_wrap__62eIC .footer_footer_social_links__nTS8Y a::before {
  content: none !important;
}
.footer_footer_section__YRY81 .footer_main__Dmzml .footer_logo_part__txaGp .footer_our_social_wrap__62eIC .footer_footer_social_links__nTS8Y:hover {
  border: 2px solid var(--green-light);
  background-color: var(--green-light);
  transition: all 0.3s;
}
.footer_footer_section__YRY81 .footer_main__Dmzml .footer_logo_part__txaGp .footer_our_social_wrap__62eIC .footer_footer_social_links__nTS8Y:active {
  transform: scale(0.9);
  transition: all 0.3s;
}
.footer_footer_section__YRY81 .footer_main__Dmzml .footer_info_part__vXdzR {
  width: 75%;
  font-size: 14px;
  line-height: 18px;
  font-weight: 400;
}
.footer_footer_section__YRY81 .footer_main__Dmzml .footer_info_part__vXdzR .footer_top__Eebxf {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  min-height: 230px;
  padding-top: 10px;
  margin-bottom: 20px;
}
.footer_footer_section__YRY81 .footer_main__Dmzml .footer_info_part__vXdzR .footer_top__Eebxf div {
  width: 30%;
  line-height: 24px;
}
.footer_footer_section__YRY81 .footer_main__Dmzml .footer_info_part__vXdzR .footer_top__Eebxf a {
  color: var(--primary-color);
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
  width: 100%;
}
.footer_footer_section__YRY81 .footer_main__Dmzml .footer_info_part__vXdzR .footer_top__Eebxf .footer_left__\\+W6qx {
  margin-bottom: 20px;
}
.footer_footer_section__YRY81 .footer_main__Dmzml .footer_info_part__vXdzR .footer_top__Eebxf .footer_city__lkk14 {
  position: relative;
  font-weight: 700;
  font-size: 21px;
  margin-bottom: 15px;
}
.footer_footer_section__YRY81 .footer_main__Dmzml .footer_info_part__vXdzR .footer_top__Eebxf .footer_city__lkk14::before {
  content: "";
  position: absolute;
  width: 100px;
  border-bottom: 1px solid var(--border-default-color);
  bottom: -7px;
  left: 0;
}
.footer_footer_section__YRY81 .footer_main__Dmzml .footer_info_part__vXdzR .footer_top__Eebxf .footer_address__1gqox {
  display: flex;
  flex-direction: column;
}
.footer_footer_section__YRY81 .footer_main__Dmzml .footer_info_part__vXdzR .footer_top__Eebxf .footer_right__J29ge {
  display: flex;
  align-items: center;
  margin-bottom: 40px;
}
.footer_footer_section__YRY81 .footer_main__Dmzml .footer_info_part__vXdzR .footer_top__Eebxf .footer_right__J29ge .footer_appointment_link__ry7oa {
  width: fit-content;
  line-height: 16px;
}
.footer_footer_section__YRY81 .footer_main__Dmzml .footer_info_part__vXdzR .footer_top__Eebxf .footer_right__J29ge .footer_appointment_link__ry7oa a::before {
  content: none;
}
.footer_footer_section__YRY81 .footer_main__Dmzml .footer_info_part__vXdzR .footer_bottom__\\+DYth {
  display: flex;
  justify-content: space-between;
  gap: 20px;
}
.footer_footer_section__YRY81 .footer_main__Dmzml .footer_info_part__vXdzR .footer_bottom__\\+DYth div {
  width: 30%;
}
.footer_footer_section__YRY81 .footer_main__Dmzml .footer_info_part__vXdzR .footer_bottom__\\+DYth .footer_title__kLu66 {
  font-weight: 700;
  font-size: 21px;
  line-height: 1;
  margin-bottom: 15px;
}
.footer_footer_section__YRY81 .footer_main__Dmzml .footer_info_part__vXdzR .footer_bottom__\\+DYth ul {
  list-style-type: none;
  padding: 0;
}
.footer_footer_section__YRY81 .footer_main__Dmzml .footer_info_part__vXdzR .footer_bottom__\\+DYth ul div {
  width: 100%;
  margin-bottom: 10px;
}
.footer_footer_section__YRY81 .footer_main__Dmzml .footer_info_part__vXdzR .footer_bottom__\\+DYth ul div a {
  color: #000000 !important;
  text-decoration: none;
  transition: all 0.3s;
}
.footer_footer_section__YRY81 .footer_main__Dmzml .footer_info_part__vXdzR .footer_bottom__\\+DYth ul div a::before {
  content: none;
}
.footer_footer_section__YRY81 .footer_main__Dmzml .footer_info_part__vXdzR .footer_bottom__\\+DYth ul div a:hover {
  color: var(--primary-color) !important;
  text-decoration: underline;
  transition: all 0.3s;
}
.footer_footer_section__YRY81 .footer_copyright__C4rPS {
  text-align: center;
  padding: 20px 0;
}
@media (max-width: 1199px) {
  .footer_footer_section__YRY81 {
    padding-top: 20px;
  }
  .footer_footer_section__YRY81 .footer_main__Dmzml .footer_logo_part__txaGp .footer_logo_link__LC4y2 {
    width: 120px;
  }
  .footer_footer_section__YRY81 .footer_main__Dmzml .footer_logo_part__txaGp .footer_our_social_wrap__62eIC .footer_title__kLu66 {
    font-size: 18px;
  }
  .footer_footer_section__YRY81 .footer_main__Dmzml .footer_logo_part__txaGp .footer_our_social_wrap__62eIC .footer_footer_social_links__nTS8Y {
    width: 30px;
    height: 30px;
  }
  .footer_footer_section__YRY81 .footer_main__Dmzml .footer_logo_part__txaGp .footer_our_social_wrap__62eIC .footer_footer_social_links__nTS8Y a {
    text-align: center;
  }
  .footer_footer_section__YRY81 .footer_main__Dmzml .footer_logo_part__txaGp .footer_our_social_wrap__62eIC .footer_footer_social_links__nTS8Y a img {
    width: 80%;
  }
  .footer_footer_section__YRY81 .footer_main__Dmzml .footer_info_part__vXdzR .footer_top__Eebxf {
    min-height: 204px;
  }
  .footer_footer_section__YRY81 .footer_main__Dmzml .footer_info_part__vXdzR .footer_top__Eebxf .footer_city__lkk14 {
    font-size: 18px;
    margin-bottom: 20px;
  }
  .footer_footer_section__YRY81 .footer_main__Dmzml .footer_info_part__vXdzR .footer_top__Eebxf .footer_city__lkk14::before {
    bottom: -5px;
  }
  .footer_footer_section__YRY81 .footer_main__Dmzml .footer_info_part__vXdzR .footer_top__Eebxf .footer_right__J29ge .footer_appointment_link__ry7oa a {
    padding: 10px 20px;
  }
  .footer_footer_section__YRY81 .footer_main__Dmzml .footer_info_part__vXdzR .footer_bottom__\\+DYth .footer_title__kLu66 {
    font-size: 18px;
  }
}
@media (max-width: 991px) {
  .footer_footer_section__YRY81 {
    padding-top: 20px;
  }
  .footer_footer_section__YRY81 .footer_main__Dmzml .footer_logo_part__txaGp .footer_logo_link__LC4y2 {
    width: 100px;
    margin-bottom: 100px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/Footer/footer.module.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;AACF;AACE;EACE,aAAA;EACA,oBAAA;AACJ;AACI;EACE,UAAA;AACN;AACM;EACE,mBAAA;EACA,YAAA;EACA,kBAAA;AACR;AAAQ;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;AAEV;AACU;EACE,wBAAA;AACZ;AAKQ;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAHV;AAMQ;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sCAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;AAJV;AAOY;EACE,wBAAA;AALd;AASU;EACE,oCAAA;EACA,oCAAA;EACA,oBAAA;AAPZ;AAUU;EACE,qBAAA;EACA,oBAAA;AARZ;AAcI;EACE,UAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAZN;AAcM;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;AAZR;AAcQ;EACE,UAAA;EACA,iBAAA;AAZV;AAeQ;EACE,2BAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;AAbV;AAgBQ;EACE,mBAAA;AAdV;AAiBQ;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAfV;AAiBU;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,oDAAA;EACA,YAAA;EACA,OAAA;AAfZ;AAmBQ;EACE,aAAA;EACA,sBAAA;AAjBV;AAoBQ;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAlBV;AAoBU;EACE,kBAAA;EACA,iBAAA;AAlBZ;AAqBc;EACE,aAAA;AAnBhB;AA0BM;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAxBR;AA0BQ;EACE,UAAA;AAxBV;AA2BQ;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AAzBV;AA4BQ;EACE,qBAAA;EACA,UAAA;AA1BV;AA4BU;EACE,WAAA;EACA,mBAAA;AA1BZ;AA4BY;EACE,yBAAA;EACA,qBAAA;EACA,oBAAA;AA1Bd;AA4Bc;EACE,aAAA;AA1BhB;AA6Bc;EACE,sCAAA;EACA,0BAAA;EACA,oBAAA;AA3BhB;AAoCE;EACE,kBAAA;EACA,eAAA;AAlCJ;AAqCE;EAzLF;IA0LI,iBAAA;EAlCF;EAsCM;IACE,YAAA;EApCR;EAwCQ;IACE,eAAA;EAtCV;EAyCQ;IACE,WAAA;IACA,YAAA;EAvCV;EAyCU;IACE,kBAAA;EAvCZ;EAwCY;IACE,UAAA;EAtCd;EA8CM;IACE,iBAAA;EA5CR;EA8CQ;IACE,eAAA;IACA,mBAAA;EA5CV;EA8CU;IACE,YAAA;EA5CZ;EAkDY;IACE,kBAAA;EAhDd;EAuDQ;IACE,eAAA;EArDV;AACF;AA2DE;EApPF;IAqPI,iBAAA;EAxDF;EA4DM;IACE,YAAA;IACA,oBAAA;EA1DR;AACF","sourcesContent":[".footer_section {\n  padding: 50px 30px 0;\n\n  .main {\n    display: flex;\n    padding-bottom: 50px;\n\n    .logo_part {\n      width: 25%;\n\n      .logo_link {\n        margin-bottom: 80px;\n        width: 150px;\n        border-radius: 50%;\n        img {\n          width: 100%;\n          object-fit: contain;\n          border-radius: 50%;\n        }\n        a {\n          &::before {\n            content: none !important;\n          }\n        }\n      }\n\n      .our_social_wrap {\n        .title {\n          font-weight: 700;\n          font-size: 21px;\n          line-height: 18px;\n          margin-bottom: 15px;\n        }\n\n        .footer_social_links {\n          width: 40px;\n          height: 40px;\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          border: 2px solid var(--primary-color);\n          border-radius: 50%;\n          margin-right: 10px;\n          transition: all 0.3s;\n\n          a {\n            &::before {\n              content: none !important;\n            }\n          }\n\n          &:hover {\n            border: 2px solid var(--green-light);\n            background-color: var(--green-light);\n            transition: all 0.3s;\n          }\n\n          &:active {\n            transform: scale(0.9);\n            transition: all 0.3s;\n          }\n        }\n      }\n    }\n\n    .info_part {\n      width: 75%;\n      font-size: 14px;\n      line-height: 18px;\n      font-weight: 400;\n\n      .top {\n        display: flex;\n        justify-content: space-between;\n        flex-wrap: wrap;\n        min-height: 230px;\n        padding-top: 10px;\n        margin-bottom: 20px;\n\n        div {\n          width: 30%;\n          line-height: 24px;\n        }\n\n        a {\n          color: var(--primary-color);\n          text-overflow: ellipsis;\n          overflow: hidden;\n          display: block;\n          width: 100%;\n        }\n\n        .left {\n          margin-bottom: 20px;\n        }\n\n        .city {\n          position: relative;\n          font-weight: 700;\n          font-size: 21px;\n          margin-bottom: 15px;\n\n          &::before {\n            content: \"\";\n            position: absolute;\n            width: 100px;\n            border-bottom: 1px solid var(--border-default-color);\n            bottom: -7px;\n            left: 0;\n          }\n        }\n\n        .address {\n          display: flex;\n          flex-direction: column;\n        }\n\n        .right {\n          display: flex;\n          align-items: center;\n          margin-bottom: 40px;\n\n          .appointment_link {\n            width: fit-content;\n            line-height: 16px;\n\n            a {\n              &::before {\n                content: none;\n              }\n            }\n          }\n        }\n      }\n\n      .bottom {\n        display: flex;\n        justify-content: space-between;\n        gap: 20px;\n\n        div {\n          width: 30%;\n        }\n\n        .title {\n          font-weight: 700;\n          font-size: 21px;\n          line-height: 1;\n          margin-bottom: 15px;\n        }\n\n        ul {\n          list-style-type: none;\n          padding: 0;\n\n          div {\n            width: 100%;\n            margin-bottom: 10px;\n\n            a {\n              color: #000000 !important;\n              text-decoration: none;\n              transition: all 0.3s;\n\n              &::before {\n                content: none;\n              }\n\n              &:hover {\n                color: var(--primary-color) !important;\n                text-decoration: underline;\n                transition: all 0.3s;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .copyright {\n    text-align: center;\n    padding: 20px 0;\n  }\n\n  @media (max-width: 1199px) {\n    padding-top: 20px;\n\n    .main {\n      .logo_part {\n        .logo_link {\n          width: 120px;\n        }\n\n        .our_social_wrap {\n          .title {\n            font-size: 18px;\n          }\n\n          .footer_social_links {\n            width: 30px;\n            height: 30px;\n\n            a {\n              text-align: center;\n              img {\n                width: 80%;\n              }\n            }\n          }\n        }\n      }\n\n      .info_part {\n        .top {\n          min-height: 204px;\n\n          .city {\n            font-size: 18px;\n            margin-bottom: 20px;\n\n            &::before {\n              bottom: -5px;\n            }\n          }\n\n          .right {\n            .appointment_link {\n              a {\n                padding: 10px 20px;\n              }\n            }\n          }\n        }\n\n        .bottom {\n          .title {\n            font-size: 18px;\n          }\n        }\n      }\n    }\n  }\n\n  @media (max-width: 991px) {\n    padding-top: 20px;\n\n    .main {\n      .logo_part {\n        .logo_link {\n          width: 100px;\n          margin-bottom: 100px;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer_section": `footer_footer_section__YRY81`,
	"main": `footer_main__Dmzml`,
	"logo_part": `footer_logo_part__txaGp`,
	"logo_link": `footer_logo_link__LC4y2`,
	"our_social_wrap": `footer_our_social_wrap__62eIC`,
	"title": `footer_title__kLu66`,
	"footer_social_links": `footer_footer_social_links__nTS8Y`,
	"info_part": `footer_info_part__vXdzR`,
	"top": `footer_top__Eebxf`,
	"left": `footer_left__+W6qx`,
	"city": `footer_city__lkk14`,
	"address": `footer_address__1gqox`,
	"right": `footer_right__J29ge`,
	"appointment_link": `footer_appointment_link__ry7oa`,
	"bottom": `footer_bottom__+DYth`,
	"copyright": `footer_copyright__C4rPS`
};
export default ___CSS_LOADER_EXPORT___;
